import { render, staticRenderFns } from "./veStuIdxStuScoreShow.vue?vue&type=template&id=963f0f4e&scoped=true"
import script from "./veStuIdxStuScoreShow.vue?vue&type=script&lang=js"
export * from "./veStuIdxStuScoreShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963f0f4e",
  null
  
)

export default component.exports